import type { PopupContent } from '@/components/map/render/Popup/popupContent'

declare const popupContent: Record<string, PopupContent>

__EXEC(() => {
  popupContent.poi!.onMount = ({ id }, { module, setLocation }) => {
    if ((module?.module as string | undefined) !== 'schools') return
    setLocation('', { setParams: [['poi', 'schools@' + id]] })
  }
  popupContent.stop_point!.buttons = []
  popupContent.stop_area!.buttons = []
})
